import * as React from 'react';
import { LabelButton } from '@teamsnap/snap-ui';
import { useForm } from 'react-hook-form';
import FormElementHook from 'components/form/form-element-hook';

const CreateElement = FormElementHook as new () => FormElementHook;

type AddOrderLineItemDrawerProps = {
  orderLineItems: any[];
  setOrderLineItems: (data: any) => void;
  onClose: () => void;
};

const DEFAULT_VALUES = {
  name: '',
  description: '',
  amount: '',
  type: '',
};

const AddOrderLineItemDrawer = ({ orderLineItems, setOrderLineItems, onClose }: AddOrderLineItemDrawerProps) => {
  const orderLineItemForm = useForm({
    defaultValues: DEFAULT_VALUES,
  });
  const { register, handleSubmit } = orderLineItemForm;

  const saveOrderLineItem = async (values) => {
    const newItems = orderLineItems;

    newItems.push({ ...values, amount: parseFloat(values.amount) });

    setOrderLineItems(newItems);

    onClose();
  };

  return (
    <div className="Installments__form sui-w-full sui-flex sui-flex-col" id="installments-drawer">
      <div className="sui-px-2 sui-w-full">
        <form>
          <div className="sui-flex Installments__field-row">
            <div className="sui-w-5/12 Installments__field-label-col">
              <div className="Installments__label-large">Name</div>
            </div>
            <div className="sui-w-7/12 Installments__field-input-col">
              <CreateElement
                inputRef={register({
                  required: 'You must enter a name for the line item.',
                })}
                useHookResponse={orderLineItemForm}
                maxLength={100}
                type="text"
                labelHidden
                field="name"
                label="name"
                placeholder="Membership"
              />
            </div>
          </div>
          <div className="sui-flex Installments__field-row">
            <div className="sui-w-5/12 Installments__field-label-col">
              <div className="Installments__label-large">Description</div>
            </div>
            <div className="sui-w-7/12 Installments__field-input-col">
              <CreateElement
                inputRef={register({
                  required: 'You must enter a description for the line item.',
                })}
                useHookResponse={orderLineItemForm}
                type="text"
                labelHidden
                field="description"
                label="description"
                placeholder="Line item description"
              />
            </div>
          </div>
          <div className="sui-flex Installments__field-row">
            <div className="sui-w-5/12 Installments__field-label-col">
              <div className="Installments__label-large">Type</div>
            </div>
            <div className="sui-w-7/12 Installments__field-input-col">
              <CreateElement
                inputRef={register({
                  required: 'You must select a type for the line item.',
                })}
                useHookResponse={orderLineItemForm}
                type="select"
                options={[
                  { text: 'Fee', value: 'fee' },
                  { text: 'Adjustment', value: 'adjustment' },
                  { text: 'Registration Fee', value: 'registration_fee' },
                ]}
                labelHidden
                field="type"
                label="type"
              />
            </div>
          </div>
          <div className="sui-flex Installments__field-row">
            <div className="sui-w-5/12 Installments__field-label-col">
              <div className="Installments__label-large">Amount</div>
            </div>
            <div className="sui-w-7/12 Installments__field-input-col">
              <CreateElement
                inputRef={register({
                  required: 'You must enter an amount for the line item.',
                })}
                useHookResponse={orderLineItemForm}
                type="number"
                labelHidden
                placeholder="$100.00"
                field="amount"
                label="amount"
                numberInputAttributes={{ min: 0, step: 0.01 }}
              />
            </div>
          </div>
        </form>
      </div>
      <div className="sui-flex sui-justify-end">
        <div className="sui-flex sui-p-2 sui-items-center">
          <LabelButton
            labelText="Cancel"
            variantType="secondary"
            onClick={() => {
              onClose();
            }}
            size="small"
          />
          <LabelButton
            icon="add"
            iconPosition="left"
            labelText="Add"
            onClick={(e) => {
              e.preventDefault();
              handleSubmit(saveOrderLineItem)();
            }}
            size="small"
            className="sui-ml-2"
          />
        </div>
      </div>
    </div>
  );
};

export default AddOrderLineItemDrawer;
